import NoTime from "./no-time.json";
import FindTime from "./find-time.json";
import FindingGold from "./finding-gold.webp";
import Focus from "./focus.webp";
import SustainedFocus from "./sustained-focus.webp";
import Understand from "./understand.webp";
import LongTermMemory from "./long-term-memory.webp";
import FourOutOfFive from "./four-out-of-5.webp";
import NewKnowledge from "./new-knowledge.webp";
import BestThing from "./best-thing.webp";
import LearnRememberApply from "./learn-remember-apply.webp";

// Paths / Goals
import BusinessPath from "./paths/business.png";
import CommunicationPath from "./paths/communication.png";
import ConflictPath from "./paths/conflict.png";
import DecisionsPath from "./paths/decisions.png";
import FinancePath from "./paths/finance.png";
import HistoryPath from "./paths/history.png";
import JoyPath from "./paths/joy.png";
import LeadershipPath from "./paths/leadership.png";
import ProductivePath from "./paths/productive.png";
import ResiliencePath from "./paths/resilience.png";
import StressPath from "./paths/stress.png";
import EssentialPhilosophyPath from "./paths/essential-philosophy.webp";
import InterpersonalDynamicsPath from "./paths/interpersonal-dynamics.webp";

// Topics
import BusinessTopic from "./topics/business.png";
import EconomicsTopic from "./topics/economics.png";
import HealthTopic from "./topics/health.png";
import HistoryTopic from "./topics/history.png";
import LeadershipTopic from "./topics/leadership.png";
import PhilosophyTopic from "./topics/philosophy.png";
import ProductivityTopic from "./topics/productivity.png";
import PsychologyTopic from "./topics/psychology.png";
import ScienceTopic from "./topics/science-and-tech.png";
import SelfHelpTopic from "./topics/self-help.png";

// Joinnow onboarding images
import Quote1 from "./joinnow/addicting-as-social-media.webp";
import Quote2 from "./joinnow/valuable-learning-growth.webp";
import Quote3 from "./joinnow/perfect-for-busy-life.webp";
import JoinNowFindingGold from "./joinnow/finding-gold.webp";
import BiteSizedLessons from "./joinnow/bite-sized-lessons.webp";
import FindingGoldGoogleAofty from "./finding_gold_google_aofty.png";
import LearnRememberApplyBreath from "./learn_remember_apply_breath.png";

export {
  Focus,
  FindTime,
  FindingGold,
  LongTermMemory,
  NoTime,
  SustainedFocus,
  Understand,
  FourOutOfFive,
  NewKnowledge,
  BestThing,
  BusinessPath,
  CommunicationPath,
  ConflictPath,
  DecisionsPath,
  FinancePath,
  HistoryPath,
  JoyPath,
  LeadershipPath,
  ProductivePath,
  ResiliencePath,
  StressPath,
  EssentialPhilosophyPath,
  InterpersonalDynamicsPath,
  BusinessTopic,
  EconomicsTopic,
  HealthTopic,
  HistoryTopic,
  LeadershipTopic,
  PhilosophyTopic,
  ProductivityTopic,
  PsychologyTopic,
  ScienceTopic,
  SelfHelpTopic,
  Quote1,
  Quote2,
  Quote3,
  JoinNowFindingGold,
  BiteSizedLessons,
  FindingGoldGoogleAofty,
  LearnRememberApply,
  LearnRememberApplyBreath,
};
